<template>
  <div id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">

        <div class="layui-form xblock">
          <button class="layui-btn xblock-row" v-on:click="SynchronizeOrders('同步订单')"><i class="fa fa-plus"></i> 同步订单</button>
          <div class="layui-input-inline country_select xblock-row">
            <select name="status" v-model="current_status" lay-verify="required" lay-filter="status_selection">
              <option value="0">全部</option>
              <option :value="item.id" v-text="item.cn" v-for="(item,index) in status_list" v-bind:key="index"></option>
            </select>
          </div>
          <div class="layui-input-inline country_select xblock-row">
            <select name="shop" v-model="current_shop" lay-verify="required" lay-filter="shops_selection">
              <option value="0">全部</option>
              <option :value="item.id" v-text="item.name+' - '+item.country" v-for="(item,index) in shop_list"
                v-bind:key="index"></option>
            </select>
          </div>
          <div class="layui-input-inline country_select xblock-row">
            <select v-model="received_status" lay-verify="required" lay-filter="received_status">
              <option value="0">全部</option>
              <option value="1">未填写订单</option>
            </select>
          </div>
          <div class="layui-input-inline country_select xblock-row">
            <select v-model="warehouse" lay-verify="required" lay-filter="warehouse">
              <option value="0">全部</option>
              <option v-for="val in warehouseList" :value="val.id" v-text="val.name" v-if="val.state"></option>
            </select>
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" class="layui-input" id="order_date" placeholder=" - " autocomplete="off" />
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" name="username" placeholder="物流单号查询" v-on:keydown.13="get_order_list(true)" v-model="shipment_id"
              autocomplete="off" class="layui-input" />
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" name="username" placeholder="订单编号查询" v-on:keydown.13="get_order_list(true)" v-model="order_id"
              autocomplete="off" class="layui-input" />
          </div>
          <button class="layui-btn xblock-row" style="height: 36px;" lay-filter="sreach" v-on:click="get_order_list(true)"><i
              class="fa fa-search"></i></button>
          <span class="x-right xblock-row" v-text="'共有数据：'+count+ '条'"></span>
          <div class="clear-both"></div>
        </div>
        <div class="orderhint">系统会自动同步订单，可按F5刷新页面查看是否同步完成，如果未能自动同步成功，可点击上方的"同步订单"按钮，手动同步订单！</div>
        <div style="height: 61px;">
          <div class="nav-btn-arr layui-form" v-if="current_status != 5" :class="{'FloatingNav':SelectedNum > 0}">
            <ul>
              <div class="nav-icon-img" style="left: 5px;">
                <input type="checkbox" class="allflog" lay-filter="allflog" name="allflog" lay-skin="primary" >
              </div>
              <li class="nav-btn" v-on:click="ConfirmHint(6)">批量生成面单<i v-if="SelectedNum > 0" v-text="'('+SelectedNum+')'"></i></li>
              <!-- <li class="nav-btn" v-on:click="OrderBale('代打包',null,1)">批量代打包<i v-if="SelectedNum > 0" v-text="'('+SelectedNum+')'"></i></li> -->
              <li class="nav-btn" v-on:click="OrderFKg('批量首公里')">批量首公里<i v-if="SelectedNum > 0" v-text="'('+SelectedNum+')'"></i></li>
              <li class="nav-btn" v-on:click="ConfirmHint(7)">批量同步订单<i v-if="SelectedNum > 0" v-text="'('+SelectedNum+')'"></i></li>
              <li class="nav-btn" v-on:click="requireTotal">数量统计<i v-if="SelectedNum > 0" v-text="'('+SelectedNum+')'"></i></li>
              <li class="nav-btn" v-on:click="ConfirmHint(10)">关闭订单<i v-if="SelectedNum > 0" v-text="'('+SelectedNum+')'"></i></li>
            </ul>
          </div>
        </div>

        <div>
          <div class="table-box-row" :class="{'warn-order':item.iswarn}" v-for="(item,index) in list" v-bind:key="index">

            <div class="btn-arr table_head layui-form">
              <div v-if="item.order_status != 'CANCELLED'">
                <!-- <img v-if="item.isActive" v-on:click="selectbox(index)" class="nav-icon-img" src="../../../static/images/select1.png">
                <img v-else v-on:click="selectbox(index)" class="nav-icon-img" src="../../../static/images/select.png"> -->
                <div class="nav-icon-img flog-box">
                  <input type="checkbox" lay-filter="flog" name="flog" lay-skin="primary" :data-index="index" :checked="item.isActive">
                </div>
              </div>

              <button v-if="item.order_status == 'READY_TO_SHIP' && !item.tracking_no  && item.ship_status < 3" class="layui-btn layui-btn-normal"
                v-on:click="ConfirmHint(4,item)">生成面单</button>
              <!-- <button v-if="item.ship_status == 1 && item.order_status != 'CANCELLED' && item.order_status != 'UNPAID' && item.order_status != 'COMPLETED'"
                class="layui-btn" v-on:click="OrderBale('代打包',item,1)">代打包</button> -->
              <button v-if="item.ship_status == 4 || item.ship_status == 5" class="layui-btn" v-on:click="ConfirmHint(3,item)">恢复订单</button>
              <button v-if="item.tracking_no && (item.ship_status < 3 || uid == 6)" class="layui-btn layui-btn-normal"
                v-on:click="PrintOrder(item)">打印面单</button>
              <!-- <button v-on:click="ConfirmHint(8,item)" class="layui-btn layui-btn-normal">更新图片</button> -->
              <button v-if="(item.ship_status > 1 && item.ship_status < 4) && (item.order_status == 'READY_TO_SHIP' ||  item.order_status == 'PROCESSED') && item.tracking_no && !item.first_mile_tracking_number"
                class="layui-btn" v-on:click="OrderFKg('首公里',item)">首公里</button>
              <button v-if="item.ship_status == 2 && (item.order_status == 'READY_TO_SHIP' ||  item.order_status == 'PROCESSED' || item.order_status == 'SHIPPED')"
                class="layui-btn" v-on:click="OrderBale('修改快递',item,2)">修改快递</button>
              <button class="layui-btn layui-btn-warm" v-on:click="ConfirmHint(2,item)">同步订单</button>
              <button v-if="item.ship_status != 3 && item.ship_status != 5" class="layui-btn layui-btn-danger"
                v-on:click="ConfirmHint(1,item)">关闭订单</button>
            </div>

            <table class="layui-table boxlist">
              <thead>
                <tr class="order-box">
                  <th>仓库</th>
                  <th>站点</th>
                  <th>店铺名称</th>
                  <th style="min-width: 60px;">订单状态</th>
                  <th>出货天数</th>
                  <th>首公里绑定</th>
                  <th style="width: 140px;">订单编号</th>
                  <th>商品数量</th>
                  <th>订单金额</th>
                  <th>配送方式</th>
                  <th>买家</th>
                  <th>日期</th>
                </tr>
              </thead>
              <tbody id="order_list">
                <tr class="order-box">
                  <td class="warehouseTd" v-on:click="item.isWarehouse = !item.isWarehouse" v-on:mouseleave="isWarehouseFun(index)">
                    <div style="width: 45px;" v-if="item.ship_status == 1">
                      <i>-</i>
                    </div>
                    <div v-else class="warehouseBox">
                      <i v-for="val in warehouseList" v-if="item.warehouse == val.id" v-text="val.name"></i>
                      <a class="warehouseSwitch">切换<i class="iconfont">&#xe6a7;</i></a>
                    </div>
                    <ul class="warehouseList" v-if="item.isWarehouse">
                      <li v-for="val in warehouseList" v-text="val.name" v-if="val.state" v-on:click="selectWarehouse(item.id,val)"></li>
                    </ul>
                  </td>
                  <td>
                    <i v-if="item.country == 'TW'">台湾</i>
                    <i v-else-if="item.country == 'PH'">菲律宾</i>
                    <i v-else-if="item.country == 'VN'">越南</i>
                    <i v-else-if="item.country == 'TH'">泰国</i>
                    <i v-else-if="item.country == 'ID'">印尼</i>
                    <i v-else-if="item.country == 'SG'">新加坡</i>
                    <i v-else-if="item.country == 'BR'">巴西</i>
                    <i v-else-if="item.country == 'MY'">马来西亚</i>
                    <i v-else-if="item.country == 'MX'">墨西哥</i>
                    <i v-else-if="item.country == 'CO'">哥伦比亚</i>
                    <i v-else-if="item.country == 'CL'">智利</i>
                    <i v-else-if="item.country == 'PL'">波兰</i>
                    <i v-else-if="item.country == 'ES'">西班牙</i>
                    <i v-else-if="item.country == 'FR'">法国</i>
                  </td>
                  <td>
                    <i v-if="item.shop_name" v-text="item.shop_name"></i>
                    <i v-else v-text="item.shop_id"></i>
                  </td>
                  <td class="orangeTwoColor NoSelect">
                    <i v-if="item.order_status == 'UNPAID'" class="status-box status-box-red">待付款</i>
                    <i v-else-if="item.order_status == 'READY_TO_SHIP' && !item.tracking_no" class="status-box status-box-red">待处理</i>
                    <i v-else-if="(item.order_status == 'READY_TO_SHIP' || item.order_status == 'PROCESSED') && item.tracking_no" class="status-box status-box-red">待出货</i>
                    <i v-else-if="item.order_status == 'TO_RETURN'" class="status-box status-box-red">退货</i>
                    <i v-else-if="item.order_status == 'SHIPPED'" class="status-box status-box-red">运输中</i>
                    <i v-else-if="item.order_status == 'IN_CANCEL'" class="status-box status-box-red">订单取消申请</i>
                    <i v-else-if="item.order_status == 'CANCELLED'" class="status-box status-box-red">已取消</i>
                    <i v-else-if="item.order_status == 'TO_CONFIRM_RECEIVE'" class="status-box status-box-red">待完成</i>
                    <i v-else-if="item.order_status == 'COMPLETED'" class="status-box status-box-red">已完成</i>
                    <i v-else class="status-box status-box-red">未知</i>
                  </td>
                  <th>
                    <i v-text="item.order_datas.days_to_ship+'天'"></i>
                    <i style="color: #F65C5C;" v-if="item.order_datas.days_to_ship > 3">「预售」</i>
                  </th>
                  <td :class="item.first_mile_tracking_number?'':'important'">
                    <i v-if="item.first_mile_tracking_number" v-text="item.first_mile_tracking_number" v-on:click="logsearch(item.first_mile_tracking_number)"
                      class="fkghint"></i>
                    <i v-else style="font-size: 26px;color: red;">无</i>
                  </td>
                  <td v-text="item.id"></td>
                  <td v-text="item.order_datas.items && item.order_datas.items.length"></td>
                  <td>
                    <div v-if="item.order_datas.escrow_amount">
                      <i v-if="item.country == 'TW'" v-text="'NT'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'MY'" v-text="'RM'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'PH'" v-text="'₱'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'VN'" v-text="'₫'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'TH'" v-text="'฿'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'ID'" v-text="'Rp'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'SG'" v-text="'$'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'BR'" v-text="'R$'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'MX'" v-text="'MX$'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'CO'" v-text="'COP'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'CL'" v-text="'CLP'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'PL'" v-text="'zł'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'ES'" v-text="'€'+item.order_datas.escrow_amount"></i>
                      <i v-else-if="item.country == 'FR'" v-text="'€'+item.order_datas.escrow_amount"></i>
                    </div>
                  </td>
                  <th v-text="item.order_datas.shipping_carrier"></th>
                  <th v-text="item.order_datas.buyer_username"></th>
                  <td v-text="item.create_time"></td>
                </tr>

                <!-- 余额不足 -->
                <tr v-if="item.remark && item.remark.type != '其它原因'">
                  <td colspan="14" style="color:#F65C5C;">管理员备注：[<i v-text="item.remark.type"></i>]<i v-text="item.remark.remark"></i><a class="clear_message" v-on:click="ConfirmHint(9,item)">清除备注</a></td>
                </tr>

                <tr class="product_box" v-viewer>
                  <td colspan="14" class="product_box_tr" style="border:0;background-color: #FAFAFA;">
                    <div class="product_box">
                      <div class="table-header">
                        <table class="layui-table" v-for="(val,ix) in item.order_datas.items">
                          <tbody class="images">
                            <tr>
                              <td colspan="14" class="product_box_tr" style="border:0;padding:0 !important;margin-top:0;">
                                <div>
                                  <table class="layui-table" style="margin: 0;">
                                    <thead>
                                      <tr class="trth">
                                        <th style="width:80px;">图片</th>
                                        <th>数量</th>
                                        <th>ID</th>
                                        <th>SKU</th>
                                        <th style="width:350px;">名称</th>
                                        <th>规格</th>
                                        <th>货号</th>
                                        <th>价格</th>
                                        <th>货源</th>
                                        <th style="width: 100px;">操作</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr :class="val.variation_quantity_purchased > 1?'important':''">
                                        <td :class="{'hintBack':!val.isTrue}">
                                          <div class="table_img"><img :src="val.img"></div>
                                        </td>
                                        <td class="redColor sku_number" v-text="'x'+val.variation_quantity_purchased"></td>
                                        <td v-text="val.item_id"></td>
                                        <td style="width:150px;word-break:break-all;" v-text="val.item_sku"></td>
                                        <td>
                                          <div class="onlyOneRow" style="width:350px;" v-text="val.item_name"></div>
                                        </td>
                                        <td v-text="val.variation_name"></td>
                                        <td v-text="val.variation_sku"></td>
                                        <td>
                                          <div>
                                            <i v-if="item.country == 'TW'" v-text="'NT'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'PH'" v-text="'₱'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'VN'" v-text="'₫'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'TH'" v-text="'฿'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'ID'" v-text="'Rp'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'SG'" v-text="'$'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'BR'" v-text="'R$'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'MX'" v-text="'MX$'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'CO'" v-text="'COP'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'CL'" v-text="'CLP'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'PL'" v-text="'zł'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'ES'" v-text="'€'+val.variation_original_price"></i>
                                            <i v-else-if="item.country == 'FR'" v-text="'€'+val.variation_original_price"></i>
                                          </div>
                                        </td>
                                        <td class="sku-hover" style="width:100px;cursor: pointer;" v-on:click="CommoditySource(val.item_sku)">点击前往</td>
                                        <td>
                                          <button class="layui-btn layui-btn-primary" v-on:click="ReturnPro(item,val)">申请退货</button>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>

                            <tr v-if="val.shipment_number&&val.shipment_number.length > 0">
                              <td colspan="14" style="padding:0;border:0;">
                                <div>
                                  <table class="layui-table" style="margin: 0;">
                                    <tbody>
                                      <tr v-for="lognum in val.shipment_number" class="loglistborder">
                                        <td style="width: 280px;">
                                          <div class="loglist" v-if="lognum.number">
                                            <i class="ship_number" v-on:click="logsearch(lognum.number,val)">快递单号：{{lognum.number}}</i>
                                            <i v-if="lognum.uid" class="redColor">〈已签收〉</i>
                                            <i v-else class="greenColor">〈未签收〉</i>
                                          </div>
                                          <div v-else>备注：无</div>
                                        </td>
                                        <td>
                                          <div v-if="lognum.is_verify_photo == 1 && lognum.is_handle == 1">
                                            <a class="redColor">〈已检测〉：</a>
                                            <a v-for="(v,vix) in lognum.verify_photo" class="logImgs">
                                              <a class="execption_img" v-if="vix == 0" v-text="'图片#'+(vix+1)" :href="v" target="view_window"></a>
                                              <a class="execption_img" v-else v-text="'，图片#'+(vix+1)" :href="v" target="view_window"></a>
                                            </a>
                                          </div>
                                          <div v-if="lognum.is_verify_photo == 1 && lognum.is_handle == 0">
                                            <a class="greenColor">〈待检测〉</a>
                                          </div>
                                        </td>
                                        <td>
                                          <div v-if="lognum.remark" style="color: red;">备注：{{lognum.remark}}</div>
                                          <div v-else>备注：无</div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                            <tr v-else>
                              <td colspan="14" style="padding:0;border:0;">
                                <div>
                                  <table class="layui-table" style="margin: 0;">
                                    <tbody>
                                      <tr class="loglistborder">
                                        <td style="width: 280px;">
                                          <div class="loglist">
                                            <i class="ship_number">快递单号：无</i>
                                          </div>
                                        </td>
                                        <td>
                                          <div>备注：无</div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>

                <!-- 底部内容 -->
                <tr>
                  <td class="table_footer_box" colspan="14">
                    <div>
                      <ul class="table_footer">
                        <li>
                          <p>打包状态：</p>
                          <p class="NoSelect">
                            <i v-if="item.ship_status == 1" class="status-box status-box-green">待打包</i>
                            <i v-else-if="item.ship_status == 2" class="status-box status-box-blue">已提交</i>
                            <i v-else-if="item.ship_status == 3" class="status-box status-box-blue">已完成</i>
                            <i v-else-if="item.ship_status == 4" class="status-box status-box-red">异常</i>
                            <i v-else-if="item.ship_status == 5" class="status-box status-box-red">已关闭</i>
                          </p>
                        </li>
                        <li v-if="item.ship_status > 1 && item.bao_server && item.bao_server.etype">
                          <p>打包方式：</p>
                          <p class="NoSelect">
                            <i v-if="item.bao_server.etype.id == 51" class="status-box redColor" v-text="item.bao_server.etype.name"></i>
                            <i v-else-if="item.bao_server.etype.id == 54" class="status-box redTwoColor" v-text="item.bao_server.etype.name"></i>
                            <i v-else class="status-box greenColor" v-text="item.bao_server.etype.name"></i>
                          </p>
                        </li>
                        <li v-if="item.ship_status > 1 && item.bao_server && item.bao_server.gift">
                          <p>礼品：</p>
                          <p class="NoSelect">
                            <i v-if="item.bao_server.gift.name == '无'" v-text="item.bao_server.gift.name"></i>
                            <i v-else style="color: red;" v-text="item.bao_server.gift.name"></i>
                          </p>
                        </li>
                        <li v-if="item.ship_status > 1 && item.bao_server && item.bao_server.consumables">
                          <p>耗材：</p>
                          <p class="NoSelect">
                            <i v-if="item.bao_server.consumables.name == '默认耗材'" v-text="item.bao_server.consumables.name"></i>
                            <i v-else style="color: red;" v-text="item.bao_server.consumables.name"></i>
                          </p>
                        </li>

                        <!-- 异常状态 -->
                        <li v-if="item.ship_status == 4">
                          <p>异常原因：</p>
                          <p class="status-error" v-text="item.execption_type"></p>
                        </li>
                        <li v-if="item.ship_status == 4">
                          <p>异常图片：</p>
                          <p class="status-error">
                            <a v-for="(img,index) in item.execption_img" class="execption_img">
                              <a class="execption_img" v-if="index == 0" v-text="'图片#'+(index+1)" :href="img" target="view_window"></a>
                              <a class="execption_img" v-else v-text="'，图片#'+(index+1)" :href="img" target="view_window"></a>
                            </a>
                          </p>
                        </li>
                        <li v-if="item.ship_status == 4">
                          <p>异常备注：</p>
                          <p class="status-error" v-text="item.execption_remark" v-if="item.execption_remark && item.execption_remark != 'null'"></p>
                          <p class="status-error" v-else>无</p>
                        </li>
                        <!-- 异常状态 -->

                        <!-- 已完成 -->
                        <li v-if="item.ship_status == 3">
                          <p>包裹重量：</p>
                          <p class="status-error" v-text="item.weight+'g'"></p>
                        </li>
                        <li v-if="item.ship_status == 3">
                          <p>包裹费用：</p>
                          <p class="status-error" v-text="item.package_fee"></p>
                        </li>
                        <li v-if="item.ship_status == 3 || item.ship_status == 5">
                          <p>包裹图片：</p>
                          <p class="status-error">
                            <a v-for="(img,index) in item.package_img" class="execption_img">
                              <a class="execption_img" v-if="index == 0" v-text="'图片#'+(index+1)" :href="img" target="view_window"></a>
                              <a class="execption_img" v-else v-text="'，图片#'+(index+1)" :href="img" target="view_window"></a>
                            </a>
                          </p>
                        </li>
                        <li v-if="item.ship_status == 3 && item.package_at">
                          <p>打包时间：</p>
                          <p v-text="item.package_at"></p>
                        </li>
                        <!-- 已完成 -->

                        <li>
                          <p>留言备注：</p>
                          <p v-if="item.buyer_message" v-text="item.buyer_message" style="color: red;"></p>
                          <p v-else>无</p>
                        </li>
                        <li v-if="uid == 6 && item.ship_status < 3">距离订单取消：<i class="status-error" v-text="item.countdown"></i></li>
                      </ul>
                    </div>
                  </td>
                </tr>

              </tbody>

            </table>
          </div>
        </div>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

      </div>

    </div>

    <!-- 分页 -->
    <div class="page-box">
      <div id="pagebox" class="pagebox"></div>
    </div>

    <!--scroll to top-->
    <div class="scroll-top">
      <i class="fa fa-angle-up" aria-hidden="true"></i>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </div>
</template>

<script>
  var self, form, layer, laydate, laypage, list_ix, this_ix, product, layerIndex, StockBox;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Order',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        uid:null,
        name: "黑领科技",
        oid: null,
        shop_id: null,
        layerIndex: null,
        loading: false,
        isLoding: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        page_num:20,
        SelectedNum:0,
        order_id: null,
        shipment_id:null,
        received_status:0,
        warehouse:0,
        module_type: 1,
        list: [],
        item: null,
        current_shop: 0,
        shop_list: [],
        current_status: 0,
        status_list: [{
          id: 1,
          cn: '未提交'
        }, {
          id: 2,
          cn: '已提交'
        }, {
          id: 3,
          cn: '已完成'
        }, {
          id: 4,
          cn: '异常订单'
        }, {
          id: 5,
          cn: '已关闭'
        }],
        loglist: [],
        isAll: false,
        attach:[],
        number:null,
        pix:null,
        proix:null,
        warehouseList:warehouseList,
        addressList:[{
          id:1,
          phone: "自己手机（方便商家反馈问题）",
          address: "广东省东莞市常平镇漱新村荣华街22号"
        },
        {
          id:2,
          phone: "15658288706",
          address: "义乌"
        },
        {
          id:3,
          phone: "自己手机（方便商家反馈问题）",
          address: "广东省东莞市常平镇漱新村荣华街22号"
        },
        {
          id:4,
          phone: "18611195874",
          address: "上海市静安区余姚路188号"
        }]
      }
    },
    updated() {
      if (form) {
        form.render()
      }
      self.NumberCheck();
    },
    watch: {
      $route: {
        handler(nv, ov) {
          self.list = [];
          self.current_status = nv.query.te;
          self.get_order_list(true)
        }
      },
      deep: true
    },
    mounted() {
      self = this;
      self.SetNavActive("货代",self.$route.name);

      if (localStorage.getItem("ExShopee_id")) {
        self.uid = localStorage.getItem("ExShopee_id");
        self.name = self.name + localStorage.getItem("ExShopee_id")
      }

      if (self.$route.query.te) {
        self.current_status = self.$route.query.te
      }
      
      scrollTop(); //监听滚动置顶
      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laydate = layui.laydate;
        laypage = layui.laypage;

        //时间控件
        laydate.render({
          elem: '#order_date',
          range: true,
          min: self.formatDate(self.getDateThreeMonthsAgo())
        });

        //系统公告
        if(self.empty(localStorage.getItem("ExShopee_Notice"))){
          self.SystemNotification();
        }

        //状态选择
        form.on('select(status_selection)', function(data) {
          self.list = [];
          var val = $("select[name=status").val();
          self.current_status = val;
          self.get_order_list(true)
          self.GoToPage("order?te=" + val);
        });

        //状态选择
        form.on('select(received_status)', function(data) {
          self.list = [];
          self.received_status = data.value;
          self.get_order_list()
        });

        //仓库选择
        form.on('select(warehouse)', function(data) {
          self.list = [];
          self.warehouse = data.value;
          self.get_order_list()
        });

        //店铺选择
        form.on('select(shops_selection)', function(data) {
          self.list = [];
          var val = $("select[name=shop").val();
          self.current_shop = val;
          self.get_order_list(true)
        });

        //店铺选择
        form.on('submit(stockSeach)', function(data) {
          self.get_sotck_list();
        });

        //待打包
        form.on('submit(bale)', function(data) {
          // var shipment_number = $("#shipment_number").val();
          // shipment_number = shipment_number.split(/[(\r\n)\r\n]+/);
          var buyer_message = $("#buyer_message").val();
          var lognumber = $("#lognumber").val();
          var remark = $("#remark").val();
          var logid = $("#log_select").val();
          var logtxt = $("#log_select option:selected").text();
          var remark = $("#remark").val();
          var consumables = $("#consumables").val();
          var gift = $("#gift").val();
          var etype = $('#etype input[name="etype"]:checked').val();
          var consumables_name = $("#consumables option:selected").text();
          var gift_name = $("#gift option:selected").text();
          var etype_name;
          if(etype == 50){
            etype_name = "快速打包";
          }else if(etype == 54){
            etype_name = "标准打包";
          }else{
            etype_name = "精细打包";
          }

          let param = new URLSearchParams()
          var logdatas = [],idArr = [],URL;
          if(data.elem.dataset.etype == 1){
            URL = "/bale_submit/";
            $(".product_main").each(function() {
              let id = $(this).attr("data-id");
              let pid = $(this).attr("data-pid");
              let log = $(this).find(".lognumber").val();
              let remark = $(this).find(".remark").val();
              let isphoto = $(this).find(".isphoto").val();
              let stock_id = $(this).attr("data-stock_id");
              let stock_number = $(this).attr("data-stock_number");

              var datas = {
                id: id,
                pid: pid,
                log: log,
                is_verify_photo:isphoto,
                remark: remark
              }
              if(log && log == "库存"){
                datas.stock_id = stock_id;
                datas.use_stock_number = stock_number;
              }
              logdatas.push(datas)
            })

            var x = 0;
            $(".remark").each(function() {
              logdatas[x].remark = $(this).val();
              x++
            })

            if (logdatas.length > 0) {
              param.append('shipment_number', JSON.stringify(logdatas))
            }
            param.append('id', self.oid)
            param.append('shop_id', self.shop_id)
          }else{
            URL = "/bale_submits/"
            var ids = $("#ids").val();
            var logs = ids.split('\n');

            for(let i in self.list){
              if(self.list[i].isActive){
                idArr.push(self.list[i].id);
                var pid;
                var items = self.list[i].order_datas.items;
                for(let x in items){
                  if (items[x].variation_id) {
                    pid = items[x].variation_id;
                  } else {
                    pid = items[x].item_id;
                  }
                }
                for(let y in logs){
                  logdatas.push({oid:self.list[i].id,pid:pid,log:logs[y],remark:null})
                }
              }
            }
            console.log(logdatas)
            param.append('id', JSON.stringify(idArr))
            param.append('shipment_number', JSON.stringify(logdatas))
          }
          param.append('buyer_message', buyer_message)
          param.append('etype', JSON.stringify({id:etype,name:etype_name}))
          param.append('consumables', JSON.stringify({id:consumables,name:consumables_name}))
          param.append('gift', JSON.stringify({id:gift,name:gift_name}))

          //首公里
          var isFkg = $('#kilometer input[name="fkg"]:checked').val()
          if (isFkg == '是') {
            if (!logtxt) {
              self.ToastFun(1, "请选择正确的快递公司！"); //弹窗提醒
              return;
            }
            if (!lognumber) {
              self.ToastFun(1, "首公里快递单号不能为空！"); //弹窗提醒
              return;
            }
            param.append('express_sn', lognumber)
            param.append('logistics_channel_id', logid)
          }

          //识别仓库
          for(let i in self.shop_list){
            if(self.shop_list[i].id == self.shop_id){
              param.append('warehouse', self.shop_list[i].warehouse)
            }
          }

          self.loading = true;
          axios({
            method: 'post',
            url: self.GetServerUrl() + URL,
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {
            self.loading = false;

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              self.get_order_list();
              self.modal_box_close();
              self.ToastFun(0, "操作成功！"); //弹窗提醒
            }, false, true);

          }).catch(function(error) {
            self.loading = false;
            self.ToastFun(2, error); //弹窗提醒
          })
          return false;
        });

        //添加快递
        form.on('submit(addlog)', function(data) {
          var ix = data.elem.dataset.ix;
          var six = $('.Logboxlist').children().length-1;
          self.number = $(this).attr("data-number");
          var pid = $(this).attr("data-pid");
          var xhtml = "";

          xhtml +=
            '<div class="product_main" style="padding-bottom:10px !important;min-width:700px;" data-number="'+self.number+'" data-id="0" data-pid="' +
            pid + '">'

          xhtml += '<div class="layui-input-inline" style="margin-right:15px;margin-top:10px;">'
          xhtml += '<label class="layui-form-label" style="padding:9px 0;text-align:left;width:70px">快递单号</label>'
          xhtml += '<div class="layui-input-inline">'
          xhtml += '<input type="text" data-id="0" data-pid="' + pid +
            '" autocomplete="off" class="layui-input lognumber">'
          xhtml += '</div>'
          xhtml += '</div>'

          xhtml += '<div class="layui-input-inline" style="margin-right:15px;margin-top:10px;">'
          xhtml += '<label class="layui-form-label" style="padding:9px 0;text-align:left;width:70px">留言备注</label>'
          xhtml += '<div class="layui-input-inline">'
          xhtml += '<input type="text" autocomplete="off" class="layui-input remark">'
          xhtml += '</div>'
          xhtml += '</div>'
          xhtml +=
            '<button class="NoSelect layui-input-inline deleteLog NoSelect" type="button" lay-filter="stockSelect" style="background:#FFF;padding:9px 0;" lay-submit>库存选择</button>'
          xhtml +=
            '<button class="NoSelect layui-input-inline deleteLog NoSelect" type="button" lay-filter="deletelog" style="background:#FFF;padding:9px 0;padding-left:10px;" lay-submit>删除</button>'
          xhtml += '</div>'
          $(this).parent(".layui-input-item").prev(".Logboxlist").append(xhtml);

          form.render();
          return false;
        });

        //库存选择容器
        form.on('submit(stockSelect)', function(data) {

          var sku = $(this).parents(".product-fsbox").attr("data-sku");
          self.number = $(this).parents(".product-fsbox").attr("data-number");
          self.pix = $(this).parents(".product-fsbox").index();
          self.proix = $(this).parent().index();

          var w, h;
          self.etype = etype;
          if (w == null || w == '') {
            w = $(window).width() - 260;
          };
          if (h == null || h == '') {
            h = $(window).height() - 95;
          };
          StockBox = layer.open({
            type: 1,
            title: "库存选择",
            area: [w + 'px', h + 'px'],
            fixed: false, //不固定
            content: StockList,
            success: function() {
              $("#sku_parent").val(sku);
              self.get_sotck_list(sku);
              form.render();
            },
            yes: function(index, layero) {
              self.SubmitDatas();
            }
          });

          return false;
        });

        //库存选择
        form.on('submit(selectStock)', function(data) {
          layer.prompt({
            title: '使用数量',
            formType: 3,
            value: self.number,
          }, function(text, index) {
            if(text <= parseInt(data.elem.dataset.stock)){
              layer.close(index);
              layer.close(StockBox);

              $('.product-fsbox:eq('+self.pix+')').find('.product_main:eq('+self.proix+')').attr("data-stock_id",data.elem.dataset.id);
              $('.product-fsbox:eq('+self.pix+')').find('.product_main:eq('+self.proix+')').attr("data-stock_number",text);
              $('.product-fsbox:eq('+self.pix+')').find('.product_main:eq('+self.proix+')').find('.lognumber').val("库存");
              $('.product-fsbox:eq('+self.pix+')').find('.product_main:eq('+self.proix+')').find('.remark').val("数量："+text);

              // $('.product_main:eq('+self.proix+')').attr("data-stock_id",data.elem.dataset.id);
              // $('.product_main:eq('+self.proix+')').attr("data-stock_number",text);
              // $('.product_main:eq('+self.proix+')').find('.lognumber').val("库存");
              // $('.product_main:eq('+self.proix+')').find('.remark').val("数量："+text);



            }else{
              layer.msg("选择数量大于库存总和！");
            }
          });
          return false;
        });

        //删除快递
        form.on('submit(deletelog)', function(data) {
          var _this = $(this);
          var id = $(this).parent().attr("data-id");
          if (parseInt(id)) {
            let param = new URLSearchParams()
            param.append('id', id)
            axios({
              method: 'post',
              url: self.GetServerUrl() + "/del_shipment/",
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(response) {

              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                _this.parent().remove();
              }, false, true);

            }).catch(function(error) {
              console.log(error);
              self.ToastFun(2, error); //弹窗提醒
            })
          } else {
            _this.parent().remove();
          }

          return false;
        });


        //首公里绑定
        form.on('submit(firstKg)', function(data) {
          var lognumber = $("#lognumber").val();
          var logid = $("#log_select").val();
          var logtxt = $("#log_select option:selected").text();
          var url = "/frist_mile/";
          let param = new URLSearchParams()

          if (self.module_type == 3) {
            param.append('id', self.oid)
            param.append('shop_id', self.shop_id)
          } else {
            url = "/frist_miles/"
            var orderlist = self.GetSelextOrder();
            param.append('datas', JSON.stringify(orderlist))
          }

          if (!logtxt) {
            self.ToastFun(1, "请选择正确的快递公司！"); //弹窗提醒
            return;
          }
          if (!lognumber) {
            self.ToastFun(1, "首公里快递单号不能为空！"); //弹窗提醒
            return;
          }
          param.append('express_sn', lognumber)
          param.append('logistics_channel_id', logid)

          self.loading = true;
          axios({
            method: 'post',
            url: self.GetServerUrl() + url,
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(res) {
            self.loading = false;
            var json = res.data;
            layer.msg(json.msg);
            if (json.code == 200) {
              self.isAll = false;
              self.get_order_list();
              self.modal_box_close();
            } else if (json.code == 401) {
              self.GoToPage("/");
            }
          }).catch(function(error) {
            self.loading = false;
            self.ToastFun(2, error); //弹窗提醒
          })
          return false;
        });

        //同步订单
        form.on('submit(example)', function(data) {
          var shop_id = $("#shop_list").val();
          var country = $("#shop_list").find("option:selected").attr("data-country");
          var t = $("#update_date").val();
          //日期不能为空
          if (!t) {
            return;
          }

          //获取的结束时间自动加一天
          var start_time, end_time;
          self.getDate(t, function(s, e) {
            start_time = s;
            end_time = e;
          })

          self.loading = true;
          let param = new URLSearchParams()
          param.append('country', country)
          param.append('shop_id', shop_id)
          param.append('start_time', start_time)
          param.append('end_time', end_time)
          axios({
            method: 'post',
            url: self.GetServerUrl() + "/synchronize_orders/",
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {
            self.loading = false;

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              self.get_order_list();
              self.modal_box_close();
              self.ToastFun(0, "订单导入成功！"); //弹窗提醒
            }, false, true);

          }).catch(function(error) {
            self.loading = false;
            console.log(error);
          })
        });

        //退货方式
        form.on('radio(returnType)', function(data) {
          if(data.value == 0){
            $(".pickupCode").hide();
            $(".returnInfo").show();
          }else{
            $(".pickupCode").show();
            $(".returnInfo").hide();
          }
        });

        //全选
        form.on('checkbox(allflog)', function(data) {
          var child = $(".flog-box input[type='checkbox']");
          var status = data.elem.checked;
          var num = 0;
          child.each(function(index, item) {
            item.checked = data.elem.checked;
            self.list[index].isActive = status;
            if(status){
              num++
            }
          });
          form.render('checkbox');
        });

        //单选
        form.on('checkbox(flog)', function(data) {
          let ix = data.elem.dataset.index;
          let status = data.elem.checked;
          self.list[ix].isActive = status;
          form.render('checkbox');
        });

        $(".layui-body").scroll(function() {
          let scrollTop = $(this).scrollTop();
          if(scrollTop > 30){
            $(".FloatingNav").css({top:70+'px'});
          }else{
            $(".FloatingNav").css({top:'auto'});
          }
        })

        form.render();

        self.get_shop_list(); //加载店铺
        self.get_order_list(true); //加载订单
        self.get_log_list(); //获取快递渠道
        self.GetAttachList();
        self.VersionCheck(); //版本检测
      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {

          var url;
          let param = new URLSearchParams()

          if (self.Confirm.style < 6) {
            param.append('id', self.oid)
          }

          if (self.Confirm.style == 1) { //关闭订单
            url = "/close_order/"
          } else if (self.Confirm.style == 2) { //同步订单
            url = "/reload_order/"
            param.append('shop_id', self.shop_id)
          } else if (self.Confirm.style == 3) { //重新打包
            url = "/re_package_order/"
            param.append('shop_id', self.shop_id)
          } else if (self.Confirm.style == 4 || self.Confirm.style == 5) { //生成面单
            url = "/get_tracking_number/"
            param.append('shop_id', self.shop_id)
          } else if (self.Confirm.style == 6) { //批量生成面单
            url = "/get_tracking_numbers/"
            var orderlist = self.GetSelextOrder();
            param.append('datas', JSON.stringify(orderlist))
          } else if (self.Confirm.style == 7) { //批量同步订单
            url = "/reload_orders/"
            var orderlist = self.GetSelextOrder();
            param.append('datas', JSON.stringify(orderlist))
          } else if (self.Confirm.style == 8) { //更新图片
            url = "/reload_item_image/"
            param.append('id', self.oid)
          }else if (self.Confirm.style == 9){
            url = "/remark_order/"
            param.append('ids', self.oid)
            param.append('remark', false)
          }else if (self.Confirm.style == 10){
            url = "/close_orders/"
            var orderlist = self.GetSelextOrder();
            param.append('datas', JSON.stringify(orderlist))
          }

          self.Confirm.state = false;
          self.loading = true;
          axios({
            method: 'post',
            url: self.GetServerUrl() + url,
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              if (self.Confirm.style == 5) {
                self.modal_box_show(self, 'OrderBale', '待打包', self.item);
              } else if (self.Confirm.style == 7) {
                self.ToastFun(0, "操作完成！"); //弹窗提醒
                self.isAll = false;
              } else {
                self.ToastFun(0, "操作成功！"); //弹窗提醒
              }
              $('.allflog').prop('checked', false);
              self.get_order_list()
            }, false, true);

          }).catch(function(error) {
            self.loading = false;
            console.log(error);
          })

        }
      },
      VersionCheck () {
        axios({
          method: 'post',
          url: self.GetServerUrl() +"/version/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(res) {
          var json = res.data;
          if(json.code == 200){
            if(json.datas.version != localStorage.getItem("ExShopee_Version")){
              localStorage.setItem("ExShopee_Version",json.datas.version);
              window.location.reload(true);
            }
          }
        }).catch(function(error) {
          console.log(error);
        })
      },
      get_shop_list() {
        let param = new URLSearchParams()
        param.append('num', 999)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop_list/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.shop_list = datas.list;
          });

        }).catch(function(error) {
          console.log(error);
          self.ToastFun(2, error); //弹窗提醒
        })

      },
      get_order_list(s) {
        if (s) {
          self.list = []
          self.page = 1;
        }

        var t = $("#order_date").val();
        //获取的结束时间自动加一天
        var start_time, end_time;
        if (t) {
          self.getDate(t, function(s, e) {
            start_time = s;
            end_time = e;
          })
        }

        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('status', self.current_status)
        param.append('shop_id', self.current_shop)
        param.append('num', self.page_num)
        param.append('not_package', self.received_status)

        if(self.shipment_id){
          param.append('shipment', self.shipment_id)
        }
        if(self.warehouse){
          param.append('warehouse', self.warehouse)
        }
        if (self.order_id) {
          param.append('id', self.order_id)
        }else if(self.$route.query.id){
          param.append('id', self.$route.query.id)
        }
        if (start_time) {
          param.append('start_time', start_time)
        }
        if (end_time) {
          param.append('end_time', end_time)
        }

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_order_list_new/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var dataList = datas.list;
            var shiplist = datas.shipment_list;
            var item_list = datas.item_list;

            if (datas.page) {
              var pageDatas = datas.page;
              for (var item in dataList) {
                dataList[item].name = self.name; //收件人姓名
                dataList[item].isActive = false; //是否选中
                dataList[item].isWarehouse = false; //是显示切换仓库

                var dataobj = JSON.parse(dataList[item].order_datas);
                dataobj.buyer_username = self.maskString(dataobj.buyer_username);
                var productobj = null;
                if (dataList[item].product_info) {
                  productobj = JSON.parse(dataList[item].product_info);
                }
                dataList[item].product_info = productobj;

                //判断是否有图片写入
                let items = dataobj.items;
                if(dataobj.item_list){
                  items = dataobj.item_list
                }
                for (let i in items) {
                  items[i].isTrue = true;
                  items[i].shipment_number = []

                  if(!items[i].image_info){
                    if (dataList[item].product_info) {
                      let pobj = dataList[item].product_info; //获取图片信息，插入OBJ里面
                      if (pobj[i]) {
                        items[i].img = pobj[i].image; //图片写入
                      } else {
                        items[i].img = "../../../static/images/loading3.gif"; //图片写入
                      }
                    } else {
                      items[i].img = "../../../static/images/loading3.gif"; //图片写入
                    }

                    var itemid = items[i].item_id;
                    let str = items[i].variation_name;
                    let vid = items[i].variation_id;
                    let sku = str.split(",")[0];
                    if(!vid){
                      vid = items[i].item_id;
                    }
                    if (item_list && item_list[itemid]) {

                      if(item_list[itemid][vid]){
                        items[i].img = item_list[itemid][vid];
                      }else{
                        for(let z in item_list[itemid]){
                          items[i].isTrue = false;
                          items[i].img = item_list[itemid][z];
                        }
                      }
                    }
                  }else{
                    items[i].img =  items[i].image_info.image_url; //图片
                    items[i].variation_quantity_purchased = items[i].model_quantity_purchased; //数量
                    items[i].variation_id = items[i].model_id; //变体id
                    items[i].variation_sku = items[i].model_sku; //变体货号
                    items[i].variation_name = items[i].model_name; //规格
                    items[i].variation_original_price = items[i].model_discounted_price; //价格
                    dataobj.items = items;
                  }
                }

                dataList[item].order_datas = dataobj;

                //发货时间
                if(dataList[item].ship_status < 3){
                  var datearr = self.CountingDays(dataList[item].create_time, dataList[item]
                    .order_datas.create_time, dataList[
                      item].order_datas.days_to_ship, dataList[item].id);
                  dataList[item].countdown = datearr[0]; //取消时间
                  if(self.uid == 6 && datearr[1] <= 2){
                    dataList[item].iswarn = true;
                  }else{
                    dataList[item].iswarn = false;
                  }
                }

                //新版兼容
                if(dataobj.total_amount){
                  dataobj.escrow_amount = dataobj.total_amount;
                }
                if(dataobj.create_time){
                  dataList[item].create_time = self.timestampToTime(dataobj.create_time);
                }

                if(dataList[item].order_status != "READY_TO_SHIP" && dataList[item].order_status != "UNPAID" && dataList[item].order_status != "CANCELLED"){
                  dataList[item].tracking_no = true;
                }
                if(dataobj.package_list && dataobj.package_list.length > 0){
                  if(dataList[item].order_status == "PROCESSED"){
                    dataList[item].order_status = "READY_TO_SHIP";
                    dataList[item].tracking_no = dataobj.package_list[0].package_number;
                  }
                  if(dataobj.package_list[0].logistics_status == "LOGISTICS_PICKUP_DONE"){
                    dataList[item].tracking_no = dataobj.package_list[0].package_number;
                  }
                  dataobj.shipping_carrier = dataobj.package_list[0].shipping_carrier;
                }


                //订单备注
                if (dataList[item].remark && dataList[item].remark != "") {
                  dataList[item].remark = JSON.parse(dataList[item].remark);
                }

                //快递单号
                if (dataList[item].shipment_number) {
                  dataList[item].shipment_number = dataList[item].shipment_number.split(',');
                }
                //打包图片
                if (dataList[item].package_img) {
                  dataList[item].package_img = dataList[item].package_img.split(',');
                }
                //异常图片
                if (dataList[item].execption_img) {
                  dataList[item].execption_img = dataList[item].execption_img.split(',');
                }

                //快递单号
                if (shiplist.length > 0) {
                  for (let val in shiplist) {
                    if (dataList[item].id == shiplist[val].order_sn) {
                      let plist = dataList[item].order_datas.items;
                      for (let v in plist) {
                        if (plist[v].variation_id && plist[v].variation_id == shiplist[val].item_id) {
                          let lognum = null,
                            remark = null;
                          if (shiplist[val].shipment_number) {
                            lognum = shiplist[val].shipment_number;
                          }
                          if (shiplist[val].remark) {
                            remark = shiplist[val].remark;
                          }
                          if (shiplist[val].shipment_number || shiplist[val].remark) {
                            var imgs = [];
                            if(shiplist[val].verify_photo){
                              imgs = JSON.parse(shiplist[val].verify_photo);
                            }
                            plist[v].shipment_number.push({
                              sid: shiplist[val].id,
                              uid: shiplist[val].scan_recevide_uid,
                              number: lognum,
                              remark: remark,
                              is_handle: shiplist[val].is_handle,
                              is_verify_photo: shiplist[val].is_verify_photo,
                              verify_photo: imgs
                            }); //快递单号和id写入
                          }
                        } else if (plist[v].item_id == shiplist[val].item_id) {
                          var imgs = [];
                          if(shiplist[val].verify_photo){
                            imgs = JSON.parse(shiplist[val].verify_photo);
                          }
                          plist[v].shipment_number.push({
                            sid: shiplist[val].id,
                            uid: shiplist[val].scan_recevide_uid,
                            number: shiplist[val].shipment_number,
                            remark: shiplist[val].remark,
                            is_handle: shiplist[val].is_handle,
                            is_verify_photo: shiplist[val].is_verify_photo,
                            verify_photo: imgs
                          }); //快递单号和id写入
                        }
                      }
                    }
                  }
                }

                //批量生成面单
                if(self.Confirm.style == 6){
                  let list = self.list;
                  for(let y in list){
                    if(y == item){
                      dataList[item].isActive = list[y].isActive;
                    }
                  }
                }

              }
              self.list = dataList;
              // console.log(self.list);
              self.count = pageDatas.count; //页数
              self.ShowPage(self, laypage, "get_order_list", 10); //分页
              $('.pagebox').show();
            } else {
              self.list = [];
              self.count = 0; //页数
              $('.pagebox').hide();
            }
          },function(){
            //自动换页
            if (self.page > 1) {
              self.page -= 1;
              self.get_order_list();
            }
          });

        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      SynchronizeOrders(title) {
        self.module_type = 2;
        self.modal_box_show(self, 'SynchronizeOrders', title);
      },
      OrderBale(title, item, te) {
        self.module_type = 1;
        if(item){
          self.item = item;
          self.oid = item.id;
          self.shop_id = item.shop_id;

          if (te == 1) {
            if (item.tracking_no) {
              self.modal_box_show(self, 'OrderBale', title, item);
            } else {
              self.ConfirmHint(5, item); //需先生成面单
            }
          } else {
            self.modal_box_show(self, 'OrderBale', title, item);
          }
        }else{
          self.modal_box_show(self, 'OrderBatchBale', "批量代打包");
        }

      },
      OrderFKg(title, item) {
        if (item) {
          self.module_type = 3;
          self.oid = item.id;
          self.shop_id = item.shop_id;
          self.modal_box_show(self, 'FirstKg', title, item);
        } else {
          self.module_type = 4;
          self.modal_box_show(self, 'FirstKg', title);
        }

      },
      ConfirmHint(te, item) {
        if (item) {
          self.oid = item.id;
        }
        if (te == 1) {
          self.Confirm.txt = "是否确定关闭订单？"
        } else if (te == 2) {
          self.shop_id = item.shop_id;
          self.Confirm.txt = "是否确定同步Shopee订单状态？"
        } else if (te == 3) {
          self.shop_id = item.shop_id;
          self.Confirm.txt = "是否确定恢复订单？"
        } else if (te == 4) {
          self.shop_id = item.shop_id;
          self.Confirm.txt = "是否确定出货？"
        } else if (te == 5) {
          self.shop_id = item.shop_id;
          self.Confirm.txt = "待打包需要先生成面单，是否确认生成面单？"
        } else if (te == 6) {
          self.Confirm.txt = "是否确定批量生成面单？"
        } else if (te == 7) {
          self.Confirm.txt = "是否确定批量同步订单？"
        } else if (te == 8) {
          self.Confirm.txt = "是否确定个更新图片？"
        } else if (te == 9) {
          self.Confirm.txt = "是否确定清除备注？"
        } else if (te == 10) {
          self.Confirm.txt = "是否确定批量关闭订单？"
        }
        self.Confirm.style = te;
        self.Confirm.state = true;
      },
      logsearch(txt,pro) {
        var arr = ["现货","库存","不管"];
        if(self.isInArray(arr, txt)){
          localStorage.setItem("ExShopee_HistoryURL", "Stock");
          localStorage.setItem("ExShopee_NavSubIx", 1);
          if(pro.item_sku){
            window.open(self.PromoteUrl()+"/#/StockRecord?sku=" + pro.item_sku);
          }else{
            var pid = pro.item_id;
            if(pro.variation_id){
              pid = pro.variation_id;
            }
            window.open(self.PromoteUrl()+"/#/StockRecord?id=" + pid);
          }
        }else{
          window.open("https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=1&rsv_idx=1&tn=baidu&wd=" + txt)
        }
      },
      CountingDays(md, mdc, sd, id) {
        var d = 6;
        if (sd > 3) {
          d += sd - 1;
        }
        if (self.getWeek(md) > 2 && self.getWeek(md) < 6) {
          d += 2;
        } else if (self.getWeek(md) == 6) {
          d += 1;
        }
        var cd = parseInt(new Date().getTime() / 1000); //当前日期

        md = self.dateChange(d,mdc)

        var timeDiff = md - cd;
        var day = parseInt(timeDiff / 86400);
        var hour = parseInt((timeDiff % 86400) / 3600);
        var minute = parseInt((timeDiff % 3600) / 60);
        var second = parseInt((timeDiff % 60));
        var countdown;

        if (day > 0) {
          countdown = day + "天" + hour + "时" + minute + "分" + second + "秒"
        } else if (hour > 0) {
          countdown = hour + "时" + minute + "分" + second + "秒"
        } else if (minute > 0) {
          countdown = minute + "分" + second + "秒"
        } else if (second > 0) {
          countdown = second + "秒"
        } else {
          countdown = "可同步订单状态已确定是否取消！"
        }

        return [countdown,day];
      },
      getWeek(date) {
        var week = new Date(date).getDay();
        if (!new Date(date).getDay()) {
          week = 7;
        }
        return week;
      },
      dateChange(num = 1, date = false) {
        date += (86400) * num; //修改后的时间戳
        return date;
      },
      get_log_list() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/channel_list/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.loglist = datas;
          });

        }).catch(function(error) {
          console.log(error);
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      PrintOrder(item) {
        let param = new URLSearchParams()
        param.append('id', item.id)
        param.append('shop_id', item.shop_id)
        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/print_order/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {

            //跳转打印
            // window.open(datas);
            var pdfs = [];
            pdfs.push(datas);
            localStorage.setItem("ExShopee_Pdfs",JSON.stringify(pdfs));
            window.open(self.PromoteUrl()+"/#/Print");

          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      GetAttachList(item) {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_bao_server/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var list = {};
            for(let i in datas){
              if (!list.hasOwnProperty(datas[i].bao_type)) {
                list[datas[i].bao_type] = []
              }
              list[datas[i].bao_type].push(datas[i])
            }
            self.attach = list;
          }, false, false);

        }).catch(function(error) {
          console.log(error);
        })
      },
      AllSelect() {
        var datas = self.list;
        if (self.isAll) {
          for (let item in datas) {
            datas[item].isActive = false;
          }
          self.isAll = false;
        } else {
          for (let item in datas) {
            datas[item].isActive = true;
          }
          self.isAll = true;
        }
        self.list = datas;
      },
      selectbox(ix) {
        if (self.list[ix].isActive) {
          self.list[ix].isActive = false;
        } else {
          self.list[ix].isActive = true;
        }
      },
      GetSelextOrder() {
        var datas = self.list;
        var arr = {};
        for (let item in datas) {
          if (datas[item].isActive) {
            if (!arr.hasOwnProperty(datas[item].shop_id)) {
              arr[datas[item].shop_id] = []
            }
            arr[datas[item].shop_id].push(datas[item].id)
          }
        }
        return arr;
      },
      ReturnPro (item,pro) {
        console.log(item);
        var w, h;
        let l = $(".page-content").offset().left + 20;
        if (w == null || w == '') {
          w = $(window).width() - l - 20;
          if(w > 1000){
            w = 1000;
          }
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        let ReturnProBox = layer.open({
          type: 1,
          offset: '100px',
          title: "申请退货",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['确定', '取消'],
          content: ReturnProHtml,
          success: function() {

            form.render();
          },
          yes: function(index, layero) {
            var returnType = $('#returnType input[name="returnType"]:checked').val();
            var returnInfo = $("#returnInfo").val();
            var pickupCode = $("#pickupCode").val();
            var warehouse = $("#warehouse").val();
            let param = new URLSearchParams()
            param.append('order_sn', item.id)
            param.append('uid', item.uid)
            param.append('item_id', pro.item_id)
            param.append('return_type', returnType)
            param.append('warehouse', warehouse)
            param.append('item_data',JSON.stringify(pro))
            if(returnType == 0){
              param.append('addr', returnInfo)
              if(!returnInfo){
                layer.msg("退货信息不能为空！");
                return;
              }
            }else{
              param.append('pick_up_code', pickupCode)
              if(!pickupCode){
                layer.msg("取件码不能为空！");
                return;
              }
            }
            self.loading = true;
            axios({
              method: 'post',
              url: self.GetServerUrl() + "/item_return/",
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(response) {

              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                layer.close(ReturnProBox);
                layer.msg("退货申请成功，可在退货列表中查看退货进度！");
              }, false, true);

            }).catch(function(error) {
              self.loading = false;
              layer.msg(error); //弹窗提醒
            })
          }
        });
      },
      NumberCheck(){
        let num = 0;
        for(let i in self.list){
          if(self.list[i].isActive){
            num++
          }
        }
        self.SelectedNum = num;
        let scrollTop = $(".layui-body").scrollTop();
        if(scrollTop > 30){
          $(".FloatingNav").css({top:70+'px'});
        }else{
          $(".FloatingNav").css({top:'auto'});
        }
      },
      CommoditySource (sku) {
        self.LoadProduct(sku,"/get_production_list/");
      },
      LoadProduct(sku,url){
        let param = new URLSearchParams()
        param.append('sku', sku)
        param.append('shop_id', 0)
        param.append('type', 2)
        param.append('num', 20)
        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + url,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(json) {
          self.loading = false;
          var json = json.data;
          if (json.code == 200) {
            if(json.datas.list && json.datas.list.length > 0){
              window.open(json.datas.list[0].origin);
            }
          }else{
            if(url != "/get_production_merchant_list/"){
              self.LoadProduct(sku,"/get_production_merchant_list/");
            }else{
              layer.msg("未在Exshopee上架，无法查询到货源信息！");
            }
          }
        }).catch(function(error) {
          self.loading = false;
          console.log(error)
        })

      },
      SystemNotification () {
        var h;
        if (h == null || h == '') {
          h = $(window).height() - 155;
        };
        let NoticeBox = layer.open({
          type: 1,
          offset: '100px',
          title: "系统公告",
          area: ['800px', h+'px'],
          fixed: false, //不固定
          btn: ['确定'],
          content: SystemNotification,
          success: function() {
            form.render();
          },
          yes: function(index, layero) {
            localStorage.setItem("ExShopee_Notice",true);
            layer.close(NoticeBox);
          },
          end: function(){
            localStorage.setItem("ExShopee_Notice",true);
          }
        });
      },
      get_sotck_list(_sku) {
        var vid = $("#variation_id").val();
        if(!_sku){
          var sku = $("#sku_parent").val();
        }else{
          var sku = _sku;
        }
        self.loading = true;
        let param = new URLSearchParams()
        param.append('uid', localStorage.getItem("ExShopee_id"))
        if(vid){
          param.append('variation_id', vid)
        }
        if(sku){
          param.append('sku_parent', sku)
        }
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/user_items_stock/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.loading = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var xhtml = "";
            var list = datas.list;
            for(let i in list){
              if (list[i].customize_field) {
                list[i].customize_field = JSON.parse(list[i].customize_field);
              }
              xhtml += '<tr class="layui-form">'
                xhtml += '<td><div class="table_img"><img src="'+list[i].image+'"></div></td>'
                xhtml += "<td>"+list[i].customize_field.country+"</td>"
                xhtml += "<td>"+list[i].customize_field.name+"</td>"
                xhtml += "<td>"+list[i].variation_id+"</td>"
                xhtml += "<td>"+list[i].sku_parent+"</td>"
                xhtml += "<td>"+list[i].sku_name+"</td>"
                xhtml += "<td>"+list[i].name+"</td>"
                xhtml += "<td>"+list[i].stock+"</td>"
                xhtml += '<td><button type="button" lay-submit lay-filter="selectStock" data-id="'+list[i].id+'" data-stock="'+list[i].stock+'" class="layui-btn">选择</button></td>'
              xhtml += "</tr>"
            }
            $("#table-html").html(xhtml);
          });

        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      requireTotal () {
        var datas = [];
        for(let item in self.list){
          if(self.list[item].isActive){
            datas.push(self.list[item]);
          }
        }
        localStorage.setItem("ExShopee_ProductTotal",JSON.stringify(datas))

        self.$router.push({
          path: "ProductLog"
        })
      },
      selectWarehouse (id,data){
        self.loading = true;
        let param = new URLSearchParams()
        param.append('id', id)
        param.append('warehouse', data.id)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/set_order_warehouse/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.loading = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.get_order_list();
          });

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      isWarehouseFun (ix) {
        self.list[ix].isWarehouse = false;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .country_select {
    width: 120px;
  }

  .boxlist {
    margin-top: 15px;
    border: 1px solid #F3F3F3;
  }

  .btn-arr>button {
    margin-top: 0;
  }

  .switch {
    font-size: 20px;
    display: table;
    margin: 0 auto;
    cursor: pointer;
  }

  .table_footer_box {
    border: 0;
    padding: 0 !important;
  }

  .table_footer {
    overflow: hidden;
    padding: 5px 0 15px 0;
    border-top: 1px solid #F3F3F3;
  }

  .table_footer li {
    float: left;
    padding-right: 20px;
    padding-left: 20px;
    margin-top: 10px;
    border-right: 1px solid #E3E3E3;
  }

  .table_footer li:last-child {
    padding-right: 0;
    border-right: 0;
  }

  .table_footer li p {
    float: left;
    position: relative;
  }

  .table_footer a,.execption_img{
    color: #666;
    cursor: pointer;
    margin-right: 8px;
  }

  .table_footer a:hover ,.execption_img:hover{
    color: #01AAED;
  }
  .trth th {
    background-color: #fdfdfd;
  }

  .execption_img {
    margin-right: 0 !important;
  }

  .fkghint {
    cursor: pointer;
    display: inline-block;
    line-height: 18px;
    height: 18px;
    padding: 0 8px 0 8px;
    margin-bottom: 4px;
    white-space: nowrap;
    background-color: #f2fbf4;
    border: 1px solid #c5edd0;
    border-radius: 1px 10px 10px 1px;
    color: #5c7;
  }

  .addlog {
    cursor: pointer;
  }

  .inputbox {
    overflow: hidden;
    margin-bottom: 10px;
  }

  .inputbox a {
    display: block;
    float: left;
  }

  .inputbox a:first-child {
    max-width: 180px;
    width: calc(100% - 75px) !important;
  }

  .inputbox a input {
    width: calc(100% - 20px);
    padding: 0 10px;
    height: 30px;
    border: 1px solid #E3E3E3;
  }

  .inputbox a:hover {
    color: #333;
  }

  .inputbox a i:hover {
    color: #007DDB;
  }

  .inputbox a i:last-child {
    margin-left: 5px;
  }

  .inputbox a:last-child {
    width: 65px;
    line-height: 32px;
    margin-left: 10px;
  }

  .loglist {
    margin-top: 15px;
  }

  .loglist:first-child {
    margin-top: 0;
  }

  .loglistborder {
    border: 1px solid #e6e6e6;
  }

  .loglistborder td {
    padding: 15px;
    border: 0 !important;
  }

  .loglistborder:first-child {
    border-top: 0;
  }

  .xblock {
    margin-bottom: 0;
    border-bottom: 1px solid #E6E6E6;
  }

  .nav-btn-arr {
    padding: 10px;
    background-color: #f2f2f2;
  }

  .nav-btn-arr ul {
    overflow: hidden;
    position: relative;
    padding-left: 35px;
  }

  .nav-btn-arr ul li {
    float: left;
  }

  .nav-btn-arr .nav-btn {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #E2E2E2;
    background-color: #F1F1F1;
    margin-right: 5px;
    cursor: pointer;
  }

  .nav-btn-arr ul li:hover {
    background-color: #F4F4F4;
  }

  .table-box-row{
    overflow-x: auto;
  }
  .important{
    background-color: rgba(255, 0, 0, 0.05);
  }
  .important:hover{
    background-color: rgba(255, 0, 0, 0.08);
  }
  .important .sku_number{
    font-size: 25px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/logistics/Order.vue